<template>
    <main>
        <h1>会員ログイン</h1>
        <SignInForm />
    </main>
</template>

<script>
import SignInForm from '@/components/SignInForm.vue';

export default {
    components: {
        SignInForm,
    },
    layout: 'unAuthOnlyWithHeader',
};
</script>

<style lang="scss" scoped>
main {
    width: min(603px, 100%);
    min-height: 60vh;
    margin: min(128px, 13vh) auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 44px;
}
h1 {
    margin: 0;
    font-size: 2.4rem;
    color: #444;
}
</style>
